<template>
  <fieldset class="relative">
    <legend class="sr-only">Color selection options</legend>

    <ul class="list-none flex flex-wrap p-0 mb-0 -mx-2px">
      <li
        class="p-2px text-center relative mb-0 group"
        :class="itemsForDisplay.length < 14 ? 'w-1/6' : 'w-14'"
        style="max-width: 4.75rem"
        v-for="(item, i) in itemsForDisplay"
        :key="`item-${i}`"
      >
        <input
          type="radio"
          class="opacity-0 absolute"
          name="sku[0]"
          :id="`sku-${i}`"
          :value="item.sku"
          @change="$emit('select-swatch', $event)"
          :checked="item.sku === selected.sku"
        />
        <label
          class="relative block h-0 bg-white cursor-pointer overflow-hidden select-none"
          style="padding-top: 100%"
          :for="`sku-${i}`"
          v-lazyload
        >
          <img
            class="absolute top-0 left-0 object-cover"
            src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23F5F5F5' fill-opacity='0'/%3E%3C/svg%3E"
            :data-src="item.swatch.thumb || item.swatch.url"
            :alt="`${item.name} ${item.product_name} swatch`"
          />

          <span
            class="absolute inset-0 flex items-center justify-center"
            style="mix-blend-mode: screen"
            v-if="item.sku === selected.sku"
          >
            <svg
              class="inline-svg w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"
              ></path>
            </svg>
          </span>
        </label>

        <span
          class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 translate-y-1/2 z-1 pointer-events-none pb-4"
        >
          <span
            class="block triangle-after triangle-down triangle-x-center triangle-black-85 bg-black-85 text-gray-100 whitespace-nowrap leading-tight px-2 py-1 shadow"
          >
            {{ item.name || "&#8203;" }}
            <span class="block text-xs">{{ item.sku }}</span>
          </span>
        </span>
      </li>
    </ul>

    <div
      class="w-full mt-2"
      v-if="collapseLimit > 0 && items.length > collapseLimit && !showAll"
    >
      <button
        type="button"
        class="button w-full bg-gray-500 hover:bg-gray-800 px-1 py-3"
        @click="toggleShowAll"
      >
        Show {{ items.length - collapseLimit }} More
      </button>
    </div>
  </fieldset>
</template>

<script>
  export default {
    name: "ProductSwatches",

    props: {
      items: {
        default: () => [],
        type: Array,
      },

      collapseLimit: {
        default: -1,
        type: Number,
      },

      selected: {
        default: () => {},
        type: Object,
      },
    },

    data() {
      return {
        showAll: false,
      };
    },

    methods: {
      reverse(str) {
        return [...str].reverse().join("");
      },

      toggleShowAll() {
        this.showAll = !this.showAll;
      },
    },

    computed: {
      itemsForDisplay() {
        return !this.showAll && this.collapseLimit > 0
          ? this.items.slice(0, this.collapseLimit)
          : this.items;
        // .sort((a, b) => this.reverse(a.sku).localeCompare(this.reverse(b.sku)));
      },
    },
  };
</script>
